import React, { useEffect, useState } from 'react';
import {
  Notification,
  NotificationProps,
} from '@progress/kendo-react-notification';
import { FpFormattedMessage } from 'locales/FpFormattedMessage';
import { Problem } from 'types/entity';
import { FpFileDownloadProgressBar } from 'utils/FpFileDownload/FpFileDownloadProgressBar';
import { useNotificationFasade } from 'redux/notification/notification.facade';
import styles from './style.module.scss';

export interface DownloadStatus {
  url: string
  finished: boolean
}

export interface FpNotificationData {
  id: string
  messageId: string
  values?: string[]
  error?: Problem
  downloadStatus?: DownloadStatus
  fileName?: string
  type: NotificationProps['type']
}

export interface FpNotificationProps extends FpNotificationData {
  onClose: (id: string) => void
}

export function FpNotification(props: FpNotificationProps) {
  const [isDownload, setIsDownload] = useState(false);
  const [isValidationError, setIsValidationError] = useState(false);
  const value = props.values ? props.values[0] : '';
  const { setFileDownloadFinished, removeNotification } = useNotificationFasade();

  useEffect(() => {
    // バリデーションエラーの場合のみErrorにデータが入る
    setIsValidationError(!!props.error);
  }, [props.error]);

  useEffect(() => {
    // ファイルダウンロード時のみdownloadUrlにデータが入る
    setIsDownload(!!props.downloadStatus);
  }, [props.downloadStatus]);

  const onDownloadFinished = () => {
    setTimeout(() => {
      // setFileDownloadFinishedの関数を単独で別のタイムアウトを設定したら、
      // 次のダウンロードが発火されるタイミングは2秒のの他の時間に変更できます
      setFileDownloadFinished(props.id);
      removeNotification(props.id);
    }, 2000 /** 2秒 */);
  };

  return isDownload ? (
    <Notification
      type={props.type}
      className={styles.downloadNotification}
    >
      <span>{value}</span>
      <FpFileDownloadProgressBar downloadUrl={props.downloadStatus?.url || ''} fileName={props.fileName || ''} value={value} downloadFinished={onDownloadFinished} />
    </Notification>
  ) : (
    <Notification
      type={props.type}
      closable
      onClose={() => props.onClose(props.id)}
    >
      {
        isValidationError
          ? <FpFormattedMessage id={props.messageId} values={[props.error?.detail || '']} />
          : <FpFormattedMessage id={props.messageId} values={props.values} />
      }
    </Notification>
  );
}
